import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useMatchMedia } from '../../mq/esm';
import { InputAutocompleteDesktop } from './desktop/Component.desktop.js';
import { InputAutocompleteMobile } from './mobile/Component.mobile.js';
import './mobile/Component.modal.mobile.js';
import '../../popover/esm';
import '../../select/esm/shared';
import './autocomplete-field/Component.js';
import 'react-merge-refs';
import 'classnames';
import '../../input/esm/desktop';
import 'lodash.throttle';
import '../../select/esm/mobile';
import './autocomplete-mobile-field/Component.js';
import '../../form-control/esm/mobile';
import '../../input/esm/shared';
import '../../shared/esm';
import '@alfalab/hooks';
import './utils.js';

var InputAutocomplete = forwardRef(function (_a, ref) {
    var _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, _c = _a.defaultMatchMediaValue, defaultMatchMediaValue = _c === void 0 ? true : _c, mobileProps = _a.mobileProps, restProps = __rest(_a, ["breakpoint", "defaultMatchMediaValue", "mobileProps"]);
    var isDesktop = useMatchMedia("(min-width: ".concat(breakpoint, "px)"), defaultMatchMediaValue)[0];
    return isDesktop ? (React.createElement(InputAutocompleteDesktop, __assign({}, restProps, { ref: ref }))) : (React.createElement(InputAutocompleteMobile, __assign({}, restProps, mobileProps, { ref: ref })));
});

export { InputAutocomplete };
